const apiBaseUrl = process.env.WP_REST_API_URL;

function setHasFeatured(hasFeatured) {
    const eventsBackgroundElement       = document.getElementById('js-events-bg');
    const featuredEventsSectionElement = document.getElementById('js-events-featured');
    if (!eventsBackgroundElement) {
        return;
    }
    if (hasFeatured) {
        if (featuredEventsSectionElement) {
            featuredEventsSectionElement.hidden = false;
        }
        eventsBackgroundElement.classList.remove('events-bg--no-featured');
        eventsBackgroundElement.classList.add('events-bg--with-featured');
    } else {
        if (featuredEventsSectionElement) {
            featuredEventsSectionElement.hidden = true;
        }
        eventsBackgroundElement.classList.remove('events-bg--with-featured');
        eventsBackgroundElement.classList.add('events-bg--no-featured');
    }
}

(function () {
    const eventsBackgroundElement = document.getElementById('js-events-bg');
    if (eventsBackgroundElement) {
        setHasFeatured(eventsBackgroundElement.dataset.hasFeatured !== 'false');
    }
})();

const applicationState = {
    tab: 'upcoming',
    format: 'all',
    keywords: '',
    location: '',
    type: '',
    period: '',
    tag: '',
};

const eventsSectionContainer = document.querySelector('.events-section');
const eventsGridContainer    = document.getElementById('events-grid-items');
const eventsGridWrap         = document.getElementById('js-events-grid-wrap');
const eventsLoadMoreWrapper  = document.querySelector('.events-pagination');
const eventsLoadMoreButtonElement   = document.querySelector('.js-events-load-more');

function setLoading(loading) {
    if (eventsGridWrap) {
        eventsGridWrap.classList.toggle('is-loading', loading);
    }
}

if (eventsSectionContainer && eventsGridContainer) {
    const noUpcomingMessage = eventsSectionContainer.dataset.noUpcoming || 'No Upcoming Events';
    const noPastMessage     = eventsSectionContainer.dataset.noPast     || 'No Past Events';

    function getEmptyMessageHtml() {
        const messageText = applicationState.tab === 'past' ? noPastMessage : noUpcomingMessage;
        const emptyMessageTemplate = document.getElementById('events-empty-template');

        if (emptyMessageTemplate) {
            const templateClone = emptyMessageTemplate.content.cloneNode(true);
            const textNodeElement = templateClone.querySelector('.js-empty-msg-text');
            if (textNodeElement) {
                textNodeElement.textContent = messageText;
            }
            const wrapperElement = document.createElement('div');
            wrapperElement.appendChild(templateClone);
            return wrapperElement.innerHTML;
        }

        return `<div class="events-empty"><span>${messageText}</span></div>`;
    }

    function fetchEventsData(eventType) {
        if (eventType !== 'load-more') {
            setLoading(true);
        }

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                event: eventType,
                tab: applicationState.tab,
                format: applicationState.format,
                keywords: applicationState.keywords,
                location: applicationState.location,
                type: applicationState.type,
                period: applicationState.period,
                tag: applicationState.tag,
            }),
        };

        fetch(`${apiBaseUrl}/events-filter`, requestOptions)
            .then(fetchResponse => fetchResponse.json())
            .then(parsedServerResponse => {
                try {
                    parsedServerResponse = JSON.parse(parsedServerResponse);
                } catch (parseError) {
                }

                if (eventType === 'load-more') {
                    if (parsedServerResponse.html) {
                        eventsGridContainer.innerHTML += parsedServerResponse.html;
                    }
                } else {
                    eventsGridContainer.innerHTML = parsedServerResponse.html || getEmptyMessageHtml();
                }

                if (eventsLoadMoreWrapper) {
                    eventsLoadMoreWrapper.classList.toggle('hidden', !!parsedServerResponse.end);
                }
            })
            .catch(() => {
                if (eventType !== 'load-more') {
                    eventsGridContainer.innerHTML = getEmptyMessageHtml();
                }
            })
            .finally(() => {
                if (eventType !== 'load-more') {
                    setLoading(false);
                }
            });
    }

    const filterTabButtons = document.querySelectorAll('.events-tabs__btn');
    filterTabButtons.forEach(filterTabButton => {
        filterTabButton.addEventListener('click', () => {
            filterTabButtons.forEach(buttonElement => buttonElement.classList.remove('is-active'));
            filterTabButton.classList.add('is-active');
            applicationState.tab = filterTabButton.dataset.tab;
            fetchEventsData('filter');
        });
    });

    const filterFormatRadioButtons = document.querySelectorAll('input[name="event-format"]');
    filterFormatRadioButtons.forEach(formatRadioButton => {
        formatRadioButton.addEventListener('change', () => {
            applicationState.format = formatRadioButton.value;
            fetchEventsData('filter');
        });
    });

    if (eventsLoadMoreButtonElement) {
        eventsLoadMoreButtonElement.addEventListener('click', () => {
            fetchEventsData('load-more');
        });
    }

    const keywordsInputElement = document.querySelector('.js-events-filter-keywords');
    const keywordsClearButtonElement = document.querySelector('.js-events-keywords-clear');

    if (keywordsInputElement) {
        let keywordsInputDebounceTimer = null;

        keywordsInputElement.addEventListener('input', () => {
            if (keywordsClearButtonElement) {
                keywordsClearButtonElement.classList.toggle('is-visible', keywordsInputElement.value.length > 0);
            }
            clearTimeout(keywordsInputDebounceTimer);
            keywordsInputDebounceTimer = setTimeout(() => {
                applicationState.keywords = keywordsInputElement.value.trim();
                fetchEventsData('filter');
            }, 300);
        });

        if (keywordsClearButtonElement) {
            keywordsClearButtonElement.addEventListener('click', () => {
                keywordsInputElement.value = '';
                keywordsClearButtonElement.classList.remove('is-visible');
                applicationState.keywords = '';
                fetchEventsData('filter');
                keywordsInputElement.focus();
            });
        }
    }

    const dropdownContainers = document.querySelectorAll('.js-events-dropdown');

    dropdownContainers.forEach(dropdownContainerElement => {
        const dropdownTriggerElement     = dropdownContainerElement.querySelector('.js-dropdown-trigger');
        const dropdownTriggerTextElement = dropdownContainerElement.querySelector('.filter-dropdown__text');
        const dropdownOptionElements     = dropdownContainerElement.querySelectorAll('.js-dropdown-option');
        const filterKey   = dropdownContainerElement.dataset.filter;

        const dropdownClearButtonElement = dropdownContainerElement.querySelector('.js-dropdown-clear');

        if (dropdownTriggerElement) {
            dropdownTriggerElement.addEventListener('click', (clickEvent) => {
                clickEvent.stopPropagation();
                dropdownContainers.forEach(otherDropdownContainerElement => {
                    if (otherDropdownContainerElement !== dropdownContainerElement) {
                        otherDropdownContainerElement.classList.remove('is-open');
                    }
                });
                dropdownContainerElement.classList.toggle('is-open');
            });
        }

        if (dropdownClearButtonElement) {
            dropdownClearButtonElement.addEventListener('click', (clickEvent) => {
                clickEvent.stopPropagation();
                dropdownOptionElements.forEach(dropdownOptionElement => {
                    dropdownOptionElement.classList.toggle('is-active', dropdownOptionElement.dataset.value === '');
                });
                const defaultOptionElement = dropdownContainerElement.querySelector('.js-dropdown-option[data-value=""]');
                if (dropdownTriggerTextElement && defaultOptionElement) {
                    dropdownTriggerTextElement.textContent = defaultOptionElement.textContent;
                }
                dropdownContainerElement.classList.remove('has-value', 'is-open');
                applicationState[filterKey] = '';
                fetchEventsData('filter');
            });
        }

        dropdownOptionElements.forEach(dropdownOptionElement => {
            dropdownOptionElement.addEventListener('click', (clickEvent) => {
                clickEvent.stopPropagation();
                const dropdownOptionValue = dropdownOptionElement.dataset.value;

                dropdownOptionElements.forEach(optionElement => optionElement.classList.remove('is-active'));
                dropdownOptionElement.classList.add('is-active');

                if (dropdownTriggerTextElement) {
                    dropdownTriggerTextElement.textContent = dropdownOptionElement.textContent.trim();
                }
                dropdownContainerElement.classList.toggle('has-value', dropdownOptionValue !== '');
                dropdownContainerElement.classList.remove('is-open');

                applicationState[filterKey] = dropdownOptionValue;
                fetchEventsData('filter');
            });
        });
    });

    document.addEventListener('click', () => {
        dropdownContainers.forEach(dropdownContainerElement => {
            dropdownContainerElement.classList.remove('is-open');
        });
    });
}
